<script setup lang="ts"></script>

<template>
  <v-btn class="text-none quizter-btn">
    <template #default>
      <span class="quizter-btn--text">Quizter!</span>
    </template>
  </v-btn>
</template>

<style scoped lang="scss">
@font-face {
  font-family: 'Chalkduster';
  src: url('@/assets/fonts/Chalkduster.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

.quizter-btn {
  width: 100%;
  min-height: 56px;
  border-radius: 12px;
  font-size: 1.15rem;
  font-family: 'Chalkduster', sans-serif;
  background-image: url('@/assets/images/Color_BG.svg');
  background-size: cover;
  background-position: center;
  background-color: transparent !important;
  overflow: hidden;

  &::before {
    content: '';
    background-color: rgb(var(--v-theme-scrim));
    opacity: 0.1;
    position: absolute;
    inset: 0;
  }

  &--text {
    color: white !important;
    z-index: 1;
  }

  :deep(.v-btn__overlay),
  :deep(.v-btn__underlay) {
    display: none;
  }
}
</style>
